import { render, staticRenderFns } from "./GdprFormPage.vue?vue&type=template&id=bff9afbe&scoped=true&"
import script from "./GdprFormPage.vue?vue&type=script&lang=js&"
export * from "./GdprFormPage.vue?vue&type=script&lang=js&"
import style0 from "./GdprFormPage.vue?vue&type=style&index=0&id=bff9afbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff9afbe",
  null
  
)

export default component.exports